import axios from 'axios';
import ApiClient from '../apiClient';

const clientAuthService = {
  signIn: (data: any) => ApiClient.post('/auth/client/login', data),
  signUp: (data: any) => ApiClient.post('/auth/client/registration', data),
  getMe: (data: any) => ApiClient.get('/auth/client/me', data),
  getClientLvl: () => ApiClient.get('/client/lvl'),
  resetPassword: (data: any) => ApiClient.post('/auth/client/reset_password', data),
  changePassword: (data: any, token: string) =>
    ApiClient.post(`/auth/client/change_password/${token}`, data),
  changePasswordSettings: (data: any) => ApiClient.post(`/auth/client/change_password`, data),
  googleAuth: () => ApiClient.get('/auth/google/client/login'),
  googleAuthRegister: (data: any, token: string) =>
    ApiClient.post(`/auth/google/client/registration?token=${token}`, data),
  updateProfile: (data: any) => ApiClient.patch('/client', data),
  updateProfileAvatar: (data: FormData) =>
    ApiClient.post('/client/avatar', data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }),
  getDashboard: () => ApiClient.get('/client/dashboard'),
  getBalance: () => ApiClient.get('/client/balance'),
  getBalanceHistory: (params: any) => ApiClient.get('/client/balance_history', { params }),
  createPaymentInvoice: (data: any) => ApiClient.post('/client/balance', data),
  getMinimalTopUpAmount: (data: any) =>
    ApiClient.post(
      `/client/balance/min_crypto_currency_amount?crypto_currency=${data.crypto_currency}`
    ),
};

export default clientAuthService;
